"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Analytics = void 0;
var Analytics = /** @class */ (function () {
    function Analytics(campaign, analyticsTracker, disabled) {
        var _this = this;
        this.getDefaultAnalyticsProperties = function () {
            var _a;
            var campaign = _this.campaign;
            var userData = window !== undefined ? JSON.parse(window.localStorage.getItem('ahoyData') || '{}') : null;
            var crmData = window !== undefined ? JSON.parse(window.localStorage.getItem('crmData') || '{}') : null;
            return {
                campaign_id: campaign.id,
                workspace_id: campaign.creator.workspaceId,
                share_id: campaign.shareId,
                creator: campaign.creator._id,
                title: document.title,
                workspace_name: campaign.workspaceName,
                folder: campaign.folder,
                campaign_style: campaign.style,
                userData: userData,
                crmData: crmData,
                dynamic_id: (_a = campaign === null || campaign === void 0 ? void 0 : campaign.dynamicVideoProps) === null || _a === void 0 ? void 0 : _a.dynamic,
            };
        };
        this.campaign = campaign;
        this.analyticsTracker = analyticsTracker;
        this.disabled = disabled;
        this.track = this.track.bind(this);
    }
    Analytics.prototype.track = function (name, properties) {
        var _a = this, analyticsTracker = _a.analyticsTracker, getDefaultAnalyticsProperties = _a.getDefaultAnalyticsProperties, disabled = _a.disabled;
        if (disabled)
            return false;
        return !!(analyticsTracker === null || analyticsTracker === void 0 ? void 0 : analyticsTracker.track(name, __assign(__assign({}, getDefaultAnalyticsProperties()), properties)));
    };
    return Analytics;
}());
exports.Analytics = Analytics;
